import { noop } from 'lodash';
import React, { Component } from 'react';
import { SearchView } from './Search';
import styled from 'styled-components';
import { white, grey10, grey25, grey50 } from '@zocdoc/branding/colors';
import { breakpoint } from '../../../grid';
import { MobileHeader } from './MobileHeader';
import InsuranceChange from '../InsuranceChange';
import HeaderView from './Header';
import { ScanCardContainerConnector as ScanCardContainer } from '../ScanCard/ScanCardContainerConector';
import { Modal, ModalHeader, ModalBodyCopy, ModalButtonContainer } from '../../../modal';
import Button from '../../../button';
import InsuranceInfoPickerView from './InsuranceInfoPickerView';
import PropTypes from 'prop-types';

const dataProdGuid = '3db9b063';

export class InsurancePickerDropdownView extends Component {
    static propTypes = {
        showScanInsuranceCardButton: PropTypes.bool,
        recordChevronAssignment: PropTypes.func,
        useChevronDropdownHeader: PropTypes.bool,
    }

    static defaultProps = {
        recordChevronAssignment: noop,
        showScanInsuranceCardButton: false,
        useChevronDropdownHeader: false,
    }

    componentDidMount() {
        // the unit test is shallow-rendered, which doesn't do refs
        if (this.dropdown) {
            /*
             * try and save the view if it's going offscreen
             *
             * the dropdown is absolutely positioned inside of the parent,
             * so we'll inspect the viewport metrics of the parent and make adjustments as necessary
             *
             * we only need to care about if the left edge is overflowing because in small+ viewports the
             * dropdown is aligned to the right edge of the parent; for xsmall- it's a fullscreen modal
             */
            const rect = this.dropdown.getBoundingClientRect();

            if (rect.left < 0) {
                // the first parent is the transition group, we want the next level up which is the insurance wrapper
                const parentRect = this.dropdown.parentElement.parentElement.getBoundingClientRect();

                if (rect.width < window.innerWidth - parentRect.left) {
                    this.dropdown.style.left = 0;
                    this.dropdown.style.right = 'auto';
                } else {
                    this.dropdown.style.left = 0;
                    this.dropdown.style.right = 0;
                }
            }
        }
    }

    render() {
        const { showScanInsuranceCardButton, showChange } = this.props;
        return (
            <Dropdown
                data-prod-guids={`picker-dropdown:[${dataProdGuid}]`}
                data-test="picker-dropdown"
                innerRef={node => { this.dropdown = node; }}
                showChange={showChange}
            >
                <MobileHeader
                    showScanInsuranceCardButton={showScanInsuranceCardButton}
                />
                {this.renderChange()}
                {this.renderDropdownContents()}
                {this.renderScanCardMaybe()}
                {this.renderScanCardErrorModalMaybe()}
            </Dropdown>
        );
    }

    renderChange() {
        const {
            showSearch,
            showChange,
        } = this.props;

        if (showChange && !showSearch) {
            return (<InsuranceChange />);
        }
    }

    renderScanCardMaybe() {
        if (this.props.isScanCardOpen) {
            return (
                <ScanCardContainer />
            );
        }
    }

    handleClickCancel = () => this.props.setShowScanCardErrorModal(false);

    renderScanCardErrorModalMaybe() {
        if (this.props.showScanInsuranceCardErrorModal) {
            return (
                <Modal
                    data-test="scan-card-error-modal"
                    onClickCancel={this.handleClickCancel}
                >
                    <ModalHeader>Oops, something went wrong.</ModalHeader>
                    <ModalBodyCopy>
                        Sorry, we couldn{'\''}t scan your card, please select your insurance info manually.
                    </ModalBodyCopy>
                    <ModalButtonContainer>
                        <Button
                            fluid
                            onClick={this.handleClickCancel}
                        >OK, got it
                        </Button>
                    </ModalButtonContainer>
                </Modal>
            );
        }
    }

    renderDropdownContents() {
        const {
            recordChevronAssignment,
            showSearch,
            showChange,
            useChevronDropdownHeader,
        } = this.props;

        if (showChange && !showSearch) {
            return;
        }

        return (
            <DropdownContents>
                <HeaderView
                    recordChevronAssignment={recordChevronAssignment}
                    useChevronDropdownHeader={useChevronDropdownHeader}
                />
                {this.maybeRenderSearch()}
                {this.maybeRenderPicker()}
            </DropdownContents>
        );
    }

    maybeRenderSearch() {
        if (this.props.showSearch) {
            return (<SearchView />);
        }
        return null;
    }
    maybeRenderPicker() {
        if (!this.props.showSearch) {
            return (<InsuranceInfoPickerView />);
        }
        return null;
    }
}

const Dropdown = styled.div`
    position: fixed;
    height: 100%;
    left: 0;
    top: 0;
    background-color: ${white};
    z-index: 10;
    box-sizing: border-box;
    overflow: hidden;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;

    ${breakpoint.small} {
        border-left: 1px solid ${grey25};
        border-top: 1px solid ${grey10};
        border-bottom: 1px solid ${grey50};
        position: absolute;
        min-width: 532px;
        height: auto;
        right: 0;
        left: auto;
        top: auto;
        overflow: visible;
    }
`;

const DropdownContents = styled.div`
    overflow: hidden;
    position: relative;
    ${breakpoint.small} {
        min-width: 532px;
        height: 512px;
    }
`;

export const primitives = {
    Dropdown,
};
